var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveTickets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2949 1.41016L11.2949 2.72815M11.2949 5.36328L11.2949 6.68128M11.2949 9.31738L11.2949 10.6354M11.2949 13.2715L11.2949 14.5895",
    stroke: "#2DC272",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8848 5.36406C19.4301 5.36406 18.2488 6.54527 18.2488 8.00001C18.2488 9.45476 19.4301 10.636 20.8848 10.636V12.1714C20.8848 13.7388 20.0337 14.5899 18.4663 14.5899H3.53372C1.96631 14.5899 1.11523 13.7388 1.11523 12.1714V10.636C2.56994 10.636 3.75119 9.45476 3.75119 8.00001C3.75119 6.54527 2.56994 5.36406 1.11523 5.36406V3.82864C1.11523 2.26127 1.96631 1.41016 3.53372 1.41016H18.4663C20.0337 1.41016 20.8848 2.26123 20.8848 3.82864V5.36406Z",
    stroke: "#2DC272",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTickets);
export default __webpack_public_path__ + "static/media/ActiveTickets.35e094b67fb28fc0c42ec6c01410ebe8.svg";
export { ForwardRef as ReactComponent };